import { render, staticRenderFns } from "./center.vue?vue&type=template&id=cbf45d38&scoped=true&"
import script from "./center.vue?vue&type=script&lang=js&"
export * from "./center.vue?vue&type=script&lang=js&"
import style0 from "./center.vue?vue&type=style&index=0&lang=less&"
import style1 from "./center.vue?vue&type=style&index=1&id=cbf45d38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf45d38",
  null
  
)

export default component.exports